import { Component } from '@angular/core';
import { ActivateDeactivateListItemsActionComponent } from '@app/components';
import { ItemWithSelection } from '@app/shared/models/item-with-selection';

@Component({
  selector: 'app-activate-deactivate-klasa-list-items',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class ActivateDeactivateKlasaListItemsActionComponent extends ActivateDeactivateListItemsActionComponent {
  protected override getItemWithSelectionData(items: any[]): ItemWithSelection {
    return {
      $selected: items,
      $listName: this.viewName,
      $filterCriteria: (this.listViewProvider?.viewState as any)?.[
        '$filterCriteria'
      ]
    };
  }
}
